import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-check-circle",
  templateUrl: "./med-icon-check-circle.component.html",
})
export class MedIconCheckCircleComponent extends SvgMixinComponent {}
